var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 12h-1.5v1.5h1.5V12zM12.75 12h-6v1.5h6V12zM17.25 9h-1.5v1.5h1.5V9zM12.75 9h-6v1.5h6V9zM17.25 6H6.75v1.5h10.5V6z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 1.5H5.25A1.502 1.502 0 0 0 3.75 3v18.75a.75.75 0 0 0 .75.75h.75a.748.748 0 0 0 .6-.3L7.5 20l1.65 2.2a.776.776 0 0 0 1.2 0L12 20l1.65 2.2a.775.775 0 0 0 1.2 0L16.5 20l1.65 2.2a.749.749 0 0 0 .6.3h.75a.75.75 0 0 0 .75-.75V3a1.502 1.502 0 0 0-1.5-1.5zm0 19-1.65-2.2a.775.775 0 0 0-1.2 0l-1.65 2.2-1.65-2.2a.775.775 0 0 0-1.2 0l-1.65 2.2-1.65-2.2a.776.776 0 0 0-1.2 0l-1.65 2.2V3h13.5v17.5z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseWhite);
export default __webpack_public_path__ + "static/media/purchase_white.cbb3cbe596469e70fb7bc30124568b21.svg";
export { ForwardRef as ReactComponent };